module.exports = __webpack_public_path__ + "assets/img/releaseFiles-active.3828b337.svg";